var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex wrapped",class:_vm.size},_vm._l((_vm.date),function(item,key){return _c('div',{key:key,staticClass:"font-size-06 text-white chip d-flex",class:[_vm.theme, _vm.size]},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }